import React, { useState } from "react";
import Step1 from "./CreateBasicBrokeragePlan";
import Step2 from "./CreateBasicBrokeragePlanStep2";
import Step3 from "./CreateBasicBrokeragePlanStep3";
import Step4 from "./CreateBasicBrokeragePlanStep4";
import { createBaseBrokeragePlan } from "../../Services/Brokerage";
const CreateBasicBrokerageWizard = ({ onCancel, onSuccess }) => {
  const [activeStep, setActiveStep] = useState(0);
const [formData, setFormData] = useState({
  planName: "",

  // ✅ FIXED (proper defaults)
  scopeType: "project",     // "project" | "wing"
  scopeMode: "single",      // "single" | "multiple"

  // ✅ project
  selectedProject: "",
  selectedProjects: [],

  // ✅ wing (NEW STRUCTURE)
  selectedProjectWings: [],

  brokerageType: "percentage",
  percentage: "",
  fixedAmount: "",

  startDate: "",
  endDate: "",
  isActive: true,
});

  return (
    <>
      {activeStep === 0 && (
        <Step1
          data={formData}
          setData={setFormData}
          onNext={() => setActiveStep(1)}
        />
      )}

      {activeStep === 1 && (
        <Step2
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(0)}
          onNext={() => setActiveStep(2)}
        />
      )}

      {activeStep === 2 && (
        <Step3
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(1)}
          onNext={() => setActiveStep(3)}
        />
      )}

   {activeStep === 3 && (
  <Step4
    data={formData}
    onBack={() => setActiveStep(2)}
    onSubmit={async () => {

      const mappedData = {
        ...formData,
        calcType:
          formData.brokerageType === "percentage"
            ? "Percentage"
            : "Fixed",

        value:
          formData.brokerageType === "percentage"
            ? Number(formData.percentage || 0)
            : Number(formData.fixedAmount || 0),
      };

      const response = await createBaseBrokeragePlan(mappedData);

      if (response.success) {
        onSuccess();
      }
    }}
  />
)}

    </>
  );
};

export default CreateBasicBrokerageWizard;
